/*
 * CRA Shipping Protection (replaces Navidium, Oct 2026).
 * Keeps exactly one protection line in the cart, priced from the goods in it, every time the cart changes.
 * The widget itself is rendered by Liquid (snippets/cra-shipping-protection.liquid), so after any
 * Warehouse re-render it already shows the right state; this file only fixes the cart line and tracks events.
 *
 * GA4: pushes { event: 'shipping_protection', sp_action, sp_state, sp_price, sp_cart_value, sp_location } to the
 * dataLayer (GTM-N66SMB7 forwards it to GA4). sp_action = view | opt_in | opt_out | checkout.
 */
(function () {
  var C = window.CRA_SP;
  if (!C || window.__craSpLoaded) return;
  window.__craSpLoaded = true;

  var ATTR = '_shipping_protection';
  var LS_KEY = 'cra_sp_declined_at';
  var REMEMBER_DAYS = 30;
  var busy = false, again = false, pendingChoice = null;

  function isProtection(item) {
    return item.handle === C.handle;
  }
  function fee(goodsCents) {
    var dollars = Math.ceil(goodsCents * C.pct / 10000 - 1e-9);
    return Math.min(C.max, Math.max(C.min, dollars));
  }
  function api(url, body) {
    var opts = { credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
    return fetch(url, opts).then(function (r) { return r.json(); });
  }
  function rerenderCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
  }
  function rememberedDecline() {
    try {
      var at = +localStorage.getItem(LS_KEY);
      return at && Date.now() - at < REMEMBER_DAYS * 864e5;
    } catch (e) { return false; }
  }
  function rememberDecline(declined) {
    try { declined ? localStorage.setItem(LS_KEY, String(Date.now())) : localStorage.removeItem(LS_KEY); } catch (e) {}
  }

  function track(action, el, extra) {
    var w = el || document.querySelector('[data-cra-sp]');
    var data = {
      event: 'shipping_protection',
      sp_action: action,
      sp_state: w && w.querySelector('[data-cra-sp-toggle]') && w.querySelector('[data-cra-sp-toggle]').checked ? 'on' : 'off',
      sp_price: w ? +w.getAttribute('data-fee') : null,
      sp_cart_value: w ? +w.getAttribute('data-cart-value') : null,
      sp_location: w ? w.getAttribute('data-location') : null,
      currency: 'AUD'
    };
    for (var k in extra || {}) data[k] = extra[k];
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }

  // Warehouse's re-render keeps Shopify's raw item_count for the header badge (protection included),
  // so after every redraw we set it to the number of real items.
  function setBadge(cart) {
    var n = cart.items.filter(function (i) { return !isProtection(i); }).reduce(function (a, i) { return a + i.quantity; }, 0);
    document.querySelectorAll('.header__cart-count').forEach(function (el) { el.textContent = n; });
    if (window.theme) window.theme.cartCount = n;
  }

  // Bring the cart in line with the rules. Returns true when it changed something.
  // choice: 'accepted' / 'declined' from the toggle, saved in the same request as the line change.
  async function reconcile(choice) {
    if (busy) { again = true; pendingChoice = choice || pendingChoice; return false; }
    busy = true;
    var changed = false;
    try {
      var cart = await api('/cart.js');
      setBadge(cart);
      var goods = cart.items.filter(function (i) { return !isProtection(i) && !i.gift_card; });
      var goodsCents = goods.reduce(function (a, i) { return a + i.final_line_price; }, 0);
      var attr = (cart.attributes || {})[ATTR] || null;
      var attributes = null;

      if (choice && choice !== attr) { attr = choice; attributes = {}; attributes[ATTR] = choice; }
      else if (!attr && rememberedDecline()) { attr = 'declined'; attributes = {}; attributes[ATTR] = 'declined'; }

      var wantId = null;
      if (C.enabled && goods.length && attr !== 'declined' && (attr === 'accepted' || C.defaultOn)) {
        wantId = C.variants[fee(goodsCents)] ? String(C.variants[fee(goodsCents)]) : null;
      }

      // Every protection line except one correct line at quantity 1 goes.
      var updates = {}, keep = null;
      cart.items.filter(isProtection).forEach(function (i) {
        if (!keep && String(i.variant_id) === wantId) {
          keep = i;
          if (i.quantity !== 1) updates[i.key] = 1;
        } else {
          updates[i.key] = 0;
        }
      });

      if (Object.keys(updates).length || attributes) {
        var body = { updates: updates };
        if (attributes) body.attributes = attributes;
        await api('/cart/update.js', body);
        changed = true;
      }
      if (wantId && !keep) {
        var properties = {};
        if (C.disclaimer) properties['Disclaimer'] = C.disclaimer;
        // The query string keeps the product template's Klaviyo tracker (it matches the exact /cart/add.js URL)
        // from logging the protection as an "Added to Cart".
        await api('/cart/add.js?cra_sp=1', { items: [{ id: +wantId, quantity: 1, properties: properties }] });
        changed = true;
      }
    } catch (e) {
      if (window.console) console.warn('[shipping protection]', e);
    } finally {
      busy = false;
    }
    if (changed) rerenderCart();
    if (again) { var c = pendingChoice; again = false; pendingChoice = null; return reconcile(c); }
    return changed;
  }

  // The toggle: store the choice on the cart (so it reaches the order), then reconcile.
  document.addEventListener('change', async function (e) {
    var input = e.target.closest && e.target.closest('[data-cra-sp-toggle]');
    if (!input) return;
    var widget = input.closest('[data-cra-sp]');
    var on = input.checked;
    widget.classList.toggle('is-on', on);
    widget.classList.add('is-busy');
    input.disabled = true;
    rememberDecline(!on);
    track(on ? 'opt_in' : 'opt_out', widget);
    var changed = await reconcile(on ? 'accepted' : 'declined');
    if (!changed) { input.disabled = false; widget.classList.remove('is-busy'); }
  });

  // Checkout click: record the state the shopper left with (no interception, no redirect).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"]');
    if (!btn) return;
    var form = btn.closest('form');
    track('checkout', form && form.querySelector('[data-cra-sp]'));
  }, true);

  // View: once per page load per location, when the widget is really visible. The closed drawer is
  // visibility:hidden (IntersectionObserver still counts it), so check visibility too and re-check when the drawer opens.
  var seen = {};
  function isVisible(el) {
    if (el.closest('[aria-hidden="true"]')) return false;
    return el.checkVisibility ? el.checkVisibility({ visibilityProperty: true, opacityProperty: true }) : !!el.offsetParent;
  }
  function maybeView(el) {
    var loc = el.getAttribute('data-location');
    if (seen[loc] || !isVisible(el)) return;
    var r = el.getBoundingClientRect();
    if (r.bottom < 0 || r.top > window.innerHeight) return;
    seen[loc] = true;
    track('view', el);
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) maybeView(en.target); });
  }, { threshold: 0.6 }) : null;
  function observe() {
    document.querySelectorAll('[data-cra-sp]').forEach(function (w) {
      if (io && !w.__craSpObserved) { w.__craSpObserved = true; io.observe(w); }
    });
  }
  var drawer = document.getElementById('mini-cart');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (drawer.getAttribute('aria-hidden') !== 'false') return;
      // The drawer fades in, so keep checking for up to 3 s until the widget is really visible.
      var tries = 0;
      var t = setInterval(function () {
        var w = drawer.querySelector('[data-cra-sp]');
        if (w) maybeView(w);
        if (seen.drawer || ++tries >= 12 || drawer.getAttribute('aria-hidden') !== 'false') clearInterval(t);
      }, 250);
    }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  // Warehouse fires cart:rerendered on the cart element after every add / quantity change / refresh
  // (not bubbling in the drawer, hence capture).
  document.addEventListener('cart:rerendered', function () { observe(); reconcile(); }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observe(); reconcile(); });
  } else { observe(); reconcile(); }
})();
